<template>
    <div>
        <div class="row mb-8">
            <div class="col-6 d-flex justify-content-start">
                <v-card-title>
                    {{ $t('PickupPoint.PickupPoint') }}
                </v-card-title>
            </div>
            <div class="col-6 d-flex justify-content-end">
                <genericBtnComponent v-if="IsClient()" @click="AddLocation = true" svg="2"
                    :Title="$t('suppliers.edit.Location')" />
            </div>

        </div>
        <v-card elevation="0">
            <PickupPointList ref="LocationRef" />
        </v-card>
    </div>

    <AddPickupPoint v-model="AddLocation" @add-location-close-dialog="AddLocation = false" :reloadListLocation="reloadListLocation" />

</template>
<script>
import { isClient } from "@/api/index";
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import PickupPointList from "@/components/PickupPoint/PickupPointList.vue";
import AddPickupPoint from "./AddPickupPoint.vue";
export default {
    components: {
        genericBtnComponent,
        PickupPointList,
        AddPickupPoint
    },
    data() {
        return {
            showFilterDialog: false,
            AddLocation: false,
        }
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.PickupPoint');
    },
    methods: {
        reloadListLocation() {
            this.$refs.LocationRef.getPickupPointLocationlist()
        },
        IsClient() {
            return isClient()
        }
    }
};

</script>
